module.exports = __webpack_public_path__ + "img/banner_sezamo.798a9dac.png";